import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';

const DeleteMenu = ({ onDeleteButtonClick, message, renderButton }) => {
  const [deleteMenu, setDeleteMenu] = useState(null);

  const _onDeleteButtonClick = (event) => setDeleteMenu(event.currentTarget);
  const _onClose = () => setDeleteMenu(null);

  const _onMenuItemClicked = () => {
    _onClose();
    onDeleteButtonClick();
  };

  return (
    <React.Fragment>
      {renderButton(_onDeleteButtonClick)}
      <div>
        <Menu
          keepMounted
          anchorEl={deleteMenu}
          open={!!deleteMenu}
          onClose={_onClose}
        >
          <MenuItem
            onClick={_onMenuItemClicked}
            style={{ fontFamily: 'Varela Round, sans-serif' }}
          >
            {message}
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment>
  );
};

export default DeleteMenu;
